export default __webpack_public_path__ + "static/media/WAIVERAGREEMENTFHP.922baf49.docx";